// Copyright 2023, Avation Medical. All rights reserved.
// 
// This code is proprietary and confidential information of Avation Medical. Any use, reproduction, modification
// or distribution of the code without the express prior written consent of Avation Medical is strictly prohibited.

import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AccountService } from 'src/app/core/http/account/account.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { IconService } from 'src/app/core/services/icon.service';
import { handleBadRequest } from 'src/app/shared/helpers/bad-request-handler';
import { APIError } from 'src/app/shared/models/api-error.interface';
import { ConfirmAccessCodeModel } from 'src/app/shared/models/login';
import { confirmPassword } from 'src/app/shared/validators';


@Component({
  selector: 'app-confirm-access-code',
  templateUrl: './confirm-access-code.component.html',
  styleUrls: ['./confirm-access-code.component.scss']
})
export class ConfirmAccessCodeComponent implements OnInit {
  username$: Observable<string>;
  loading: boolean = false;
  errorStr: string = null;

  confirmPasswordForm = this.fb.group({
    confirmationCode: ['', [Validators.required]],
    newPassword: ['', [Validators.required]],
    passwordConfirm: ['',[Validators.required]]
  });

  hidePassword = true;

  constructor(private readonly fb: FormBuilder,
              private readonly accountService: AccountService,
              private readonly activatedRoute: ActivatedRoute,
              private readonly router: Router,
              private readonly authService: AuthService,
              private readonly iconService: IconService
            ) {    this.iconService.registerIcons(); }

  ngOnInit(): void {
    localStorage.setItem('loginMode','2')
    this.username$ = this.activatedRoute.params.pipe(map(p => p['username']));

    this.username$.subscribe(username => {
      localStorage.setItem('email', username)
    })
  }

  async submitForm(): Promise<void> {
    this.loading = true;
    let data = this.confirmPasswordForm.value as ConfirmAccessCodeModel;
    if (!this.confirmPasswordForm.invalid) {
      if (this.confirmPasswordForm.value.newPassword !== this.confirmPasswordForm.value.passwordConfirm) {
        this.errorStr = 'Passwords do not match.';
        this.loading = false;
        return;
      }
      this.username$.subscribe(username => {
        data.username = username;
        this.accountService.confirmForgotPassword(data).toPromise()
          .then(_ => this.authService.login({ username: data.username, password: data.newPassword }))
          .catch(response => {
            this.loading = false;
            if (response.error) {
              let apiError: APIError = response.error;
              this.errorStr = apiError[""][0];
            }
            handleBadRequest(this.confirmPasswordForm, response);
          })
      });
    } else {
      this.loading = false;
      return;
    }
  }

}
